export default __webpack_public_path__ + "static/media/img2.104e244e.jpg";